import { SVGProps } from 'react';

export type HexagonWithCheckProps = SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};

export const HexagonWithCheck = ({
  size = 14,
  color = '#141414',
  ...props
}: HexagonWithCheckProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M6.74805 0.459473C6.86581 0.391326 7.01212 0.392501 7.12988 0.459473L10.666 2.49658C10.7037 2.51891 10.7113 2.56955 10.6807 2.6001L9.88867 3.39404C9.86874 3.41496 9.83634 3.41976 9.81055 3.40479L7.07812 1.83057C7.03573 1.80589 6.98676 1.79346 6.93848 1.79346C6.89035 1.79353 6.84206 1.80597 6.7998 1.83057L2.52148 4.29443C2.4357 4.34493 2.38292 4.43615 2.38281 4.53467V9.46338C2.38281 9.56204 2.43556 9.65523 2.52148 9.70459L6.7998 12.1694C6.88577 12.2188 6.99216 12.2188 7.07812 12.1694L11.3574 9.70459C11.4434 9.65407 11.4961 9.56207 11.4961 9.46338V5.80225C11.4962 5.78597 11.504 5.76896 11.5156 5.75732L12.5996 4.66846C12.6407 4.62629 12.7116 4.65587 12.7119 4.71436V10.0679C12.7119 10.2276 12.6272 10.3747 12.4883 10.4546L7.12988 13.5405C7.071 13.5746 7.00443 13.5913 6.93848 13.5913C6.87269 13.5912 6.80679 13.5745 6.74805 13.5405L1.38965 10.4546C1.25071 10.3747 1.16605 10.2276 1.16602 10.0679V3.93213C1.16605 3.77237 1.25189 3.62529 1.38965 3.54541L6.74805 0.459473ZM12.4678 1.98877C12.5066 1.95117 12.5695 1.95001 12.6084 1.98877L13.3291 2.70361C13.3666 2.7424 13.3679 2.80456 13.3291 2.84326L7.07422 9.11865C7.0702 9.12239 6.98758 9.19873 6.91406 9.19873C6.84041 9.19862 6.75013 9.1174 6.74609 9.11377L4.53027 6.93408C4.4917 6.89531 4.49174 6.83312 4.5293 6.79443L5.24219 6.07178C5.28104 6.03321 5.34303 6.03333 5.38184 6.0708L6.83398 7.50146C6.8728 7.53901 6.93379 7.5391 6.97266 7.50049L12.4678 1.98877Z"
      fill={color}
    />
  </svg>
);
